export const ADD_TRANSLATIONS = 'ADD_TRANSLATIONS';
export const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE';
export const ADD_LANGUAGES = 'ADD_LANGUAGES';
export const GET_LANGUAGES = 'GET_LANGUAGES';

export const addTranslations = (language, translations) => ({
  type: ADD_TRANSLATIONS,
  payload: {
    language,
    translations,
  },
});

export const changeLanguage = language => ({
  type: CHANGE_LANGUAGE,
  payload: {
    language,
  },
});

export const addLanguages = languages => ({
  type: ADD_LANGUAGES,
  payload: {
    languages,
  },
});

export const getLanguages = salesOwnerId => ({
  type: GET_LANGUAGES,
  payload: {
    salesOwnerId,
  },
});



// WEBPACK FOOTER //
// ./src/store/lang/actions.js